import React from 'react'

import BusinessEventsPromo from '../../../../assets/images/promo-business-events.png'

import './ZapierIntegrationUpsell.scss'

export const ZapierIntegrationUpsellBody: React.FC = () => {
  return (
    <>
      <img src={BusinessEventsPromo} alt='Zapier integration promo' className='zocks-border-0.5 zapier-integration-upsell-promo object-fit-contain' />
      <div className='d-flex flex-column gap-1'>
        <h5>
          Maximize Client Signals with the <span className='zocks-text-primary'>Zapier Integration</span>
        </h5>
        <div className='paragraph-medium'>Automatically trigger your Zapier workflows when Client Signals are detected in your Account.</div>
      </div>
    </>
  )
}

export const ZapierIntegrationUpsellFeatures: React.FC = () => {
  return (
    <>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Turn conversations into action</strong>: Signals flow to 8,000+ apps the moment they're detected
        </div>
      </div>
      <div className='d-flex gap-2'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Save hours on data entry</strong>: Signals flow to Zapier without manual updates
        </div>
      </div>
      <div className='d-flex gap-2 mb-3'>
        <i className='bi bi-check-lg zocks-text-primary' />
        <div className='paragraph-medium'>
          <strong>Never miss a follow-up</strong>: Trigger workflows the moment signals are detected
        </div>
      </div>
    </>
  )
}
